import React, {
  lazy,
  useState,
  Suspense,
  Fragment,
  useEffect,
  useCallback,
  useContext,
} from 'react';
import {
  getUID,
  languageResolver,
  userAgentDetect,
} from '../utils/userResolver';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { RenderLoader } from './slashScreen';
import { isPartner } from '~/utils/checkingPartner';
import WaitingUI from '~/view/ui/components/Waiting';
import translationsUI from '~/view/ui/translationUI';
import {
  EN_DEFAULT_CODE,
  EN_MOCK,
  FR_DEFAULT_CODE,
  FR_MOCK,
  langsType,
  position_name,
  cameraConstraints4K,
  HOME_PATH,
  REACT_APP_PAVE_DASHBOARD,
} from '../utils/config';
import { parseUrlToQuery } from '~/utils/parseToQuery';
import { FormattedMessage, useIntl } from 'react-intl';
import { handleCheckingSessionID } from '~/utils/checkUrl';
import { openNotification } from '~/utils/antNotification';
import * as themeActions from '~/state/actions/theme/actions';
import { handleUserCustomTheme } from '~/utils/userCustomThemes';
import * as changeLocaleActions from '~/languageProvider/actions';
import { RootLoadingContext } from '~/contextAPI/loadingContext';
import translationsError from '../view/ui/errorPage/translationsError';
import * as sessionActions from '../state/actions/sessionProcess/actions';
import * as partnerActions from '~/state/actions/partners/partnerActions';
import * as cameraSettingActions from '~/state/actions/cameraSetting/actions';
import * as vinDecodeActions from '~/state/actions/vindecode/vinActions';
import { handleCheckingVehicle } from '~/utils/api';
import { vehicleData } from '~/utils/vehicleChecking';
import { useWindowSize } from '~/utils/gestSizeDevice';
import * as Sentry from '@sentry/react';

import {
  getSessionData,
  handleTranslateJson,
  getDisputeDetail,
} from '~/utils/api';
import { variablesBySessionStorage } from '~/utils/storagesInstantlyVariables';
import * as updateNetWorks from '../state/actions/userDetails/userDetailsActions';
import WarningModal from '~/view/ui/components/WarningModal';
import { useInvalidWarning } from '~/customHooks/useInvalidWarning';


const RootRouter = lazy(() => import('./rootRouter'));
const VinDecode = lazy(() => import('../view/containers/VinDecode'));
const OdomDecode = lazy(() => import('../view/containers/OdomDecode'));
const FlexModal = lazy(() => import('../view/ui/reusables/FlexModal'));
const RetakeUI = lazy(() => import('../view/ui/components/RetakeUI'));
const MutualModal = lazy(() => import('../view/ui/reusables/MutualModal'));

const SubRoot = (props) => {
  const [loadingDelay, setLoadingDelay] = useState(true);
  const { setloadingState } = useContext(RootLoadingContext);
  const {
    history,
    isRetake,
    vinReducer,
    odomReducer,
    themeAction,
    langReducer,
    partnerAction,
    updateNetWork,
    sessionAction,
    changeLocaleAction,
    cameraSettingAction,
    vinDecodeAction,
    themeReducer,
  } = props;
  const {
    resetNetWork,
    updateNetWorkOffLine,
    updateNetWorkOnLine,
    saveUserDetailsInfo,
  } = updateNetWork;
  const intl = useIntl();
  const { vinManual } = vinReducer;
  let vh = window.innerHeight * 0.01;
  const { isOdomDecode } = odomReducer;
  const { onSavekey, setSessionStatus } = sessionAction;
  const { savePartnerName } = partnerAction;
  const { location } = history;
  const { search, pathname, state } = location;
  const {
    getUrlParams,
    setUserCustomTheme,
    setCaptureFlow,
    setTheme,
    setPhotoDispute: setPhotoDisputeAction,
  } = themeAction;

  const { disputePhotos } = themeReducer;

  const { changeLocale, changeLangList, updateJsonLang, deviceLocale } =
    changeLocaleAction;
  const sessionIDLocal = history.location.pathname;
  const id = handleCheckingSessionID(sessionIDLocal);
  const { langsList } = langReducer;
  const { updateCameraSetting } = cameraSettingAction;

  const isLandScape = useWindowSize().width > useWindowSize().height;

  const { isWarningVisible, invalidWarning, handleWarningOk } = useInvalidWarning();


  useEffect(() => {
    try {
      // checking sessionID by Regex
      const errorMess = (
        <FormattedMessage {...translationsError.PAVE_INVALID_SESSION_ID} />
      );
      if (id) {
        const getname = isPartner(id);
        savePartnerName(getname);
        variablesBySessionStorage('SET', '_PARTNER', getname);
        onSavekey(id);
      } else {
        const defaultMess = `${intl.formatMessage(
          translationsUI.PAVE_ANT_NOTIFICATION
        )}`;

        const pathName = history?.location?.pathname;
        if (!pathName.includes('/dispute', '/stageCustomize')) {
          openNotification({
            mess: errorMess,
            time: 0,
            type: 'error',
            id: defaultMess,
          });
        }
      }
    } catch (error) {
      console.log('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    try {
      const browserUserInfo = userAgentDetect();
      if (!!browserUserInfo) {
        const resolutionLocal =
          window.screen.width * window.devicePixelRatio +
          'x' +
          window.screen.height * window.devicePixelRatio;
        let mainInfo = {
          resolution: resolutionLocal,
          uID: getUID(),
          browser: {
            name: browserUserInfo.browser.name,
            version: browserUserInfo.browser.version,
          },
          os: {
            name: browserUserInfo.os.name,
            version: browserUserInfo.os.version,
          },
          platform: {
            type: browserUserInfo.platform.type,
            model: browserUserInfo.platform.model,
          },
        };
        saveUserDetailsInfo(mainInfo || {});
      }
    } catch (error) {
      console.log('error', error);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }, [vh]);

  useEffect(() => {
    if (isLandScape) {
      document.documentElement.style.setProperty('height', `150vh`);
      setTimeout(() => {
        document.documentElement.style.setProperty('height', `auto`);
      }, 500);
    }
  }, [isLandScape]);

  const updateOnlineStatus = useCallback(() => {
    const userOnline = navigator.onLine;
    if (userOnline) {
      updateNetWorkOnLine();
      setTimeout(() => {
        resetNetWork();
      }, 2000);
      return;
    }
    updateNetWorkOffLine();
  }, [resetNetWork, updateNetWorkOffLine, updateNetWorkOnLine]);

  useEffect(() => {
    window.addEventListener('online', updateOnlineStatus);
    window.addEventListener('offline', updateOnlineStatus);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSavingLocale = async (language_code, iso) => {
    const query = {
      l: language_code,
    };
    const { data } = await handleTranslateJson(
      parseUrlToQuery(langsType.OBJ, query)
    );
    if (data.success) {
      const newJson = {
        [iso]: data.data,
      };
      updateJsonLang(newJson);
    }
  };

  const handleGetActiveLangFromUrl = async (langs) => {
    const params = parseUrlToQuery(langsType.STRING, search);
    const { localeObj, settingObj } = await languageResolver(
      langs,
      params,
      {
        changeLangList,
        getUrlParams,
        deviceLocale,
      },
      intl
    );

    await changeLocale(localeObj);
    await handleSavingLocale(settingObj.lang_code, settingObj.iso);

    history.push({
      pathname: pathname,
      search: parseUrlToQuery(langsType.OBJ, params),
      state: !!state && state,
    });
  };

  async function getDisputeDetailWithUUID() {
    if (!disputePhotos || disputePhotos.length === 0) {
      return;
    }
    const uuid = disputePhotos[0].uuid;

    getDisputeDetail(uuid).then((response) => {
      if (response.status === 200) {
        const data = response.data;

        const sessionID = data.session_key;

        // setsessionID(sessionID);

        // onSavekey(sessionID);

        if (!!response.data.qc_passed) {
          window.location.replace(
            `${REACT_APP_PAVE_DASHBOARD}/park-dispute/${uuid}`
          );

          return;
        } else {
          const photoUnFinish = data.photos.filter(
            (v) => v.status !== 'accepted'
          );

          const photoProcessing = data.photos.filter(
            (v) => v.status === 'processing'
          );

          // setCountPhotoProcessing(photoProcessing?.length ?? 0);

          if (photoUnFinish.length === 0) {
            window.location.replace(
              `${REACT_APP_PAVE_DASHBOARD}/park-dispute/${uuid}`
            );
            return;
          }

          if (data.photos !== null || data.photos?.length > 0) {
            const addUUID = [...data.photos].map((v) => ({ ...v, uuid }));
            setPhotoDisputeAction(addUUID);
          }

          // if (photoUnFinish.every((v) => v.status === 'processing')) {
          //   setTimeout(() => {
          //     setCountRefresh(countRefresh + 1);
          //   }, 3000);
          //   return;
          // }
        }

        // setPhotoDispute(data.photos);
      }
    });
  }

  useEffect(() => {
    id &&
      getSessionData(id)
        .then(({ data }) => {
          console.log('DEBUG: load session data', data);
          const {
            status,
            dealer_name,
            branding,
            customized,
            languages,
            theme,
          } = data;

          if (data.status === 'INVALID') {
            setSessionStatus({ status: 'INVALID' });
            openNotification({
              mess: intl.formatMessage(translationsUI.PAVE_SESSION_KEY_INVALID),
              time: 0,
              type: 'error',
              id: '',
            });
            setLoadingDelay(false);

            // return;
          }

          const checkTheme = handleUserCustomTheme(branding);

          setTheme(theme);

          const urlRedirect = data?.redirect_url ?? '';

          const qrScanner = customized?.qr_scanner ?? false;

          if (qrScanner) {
            vinDecodeAction.setQRScanner({ userSetting: true });
          }

          getDisputeDetailWithUUID();

          const { detectedOutline, showVehicle } = vinDecodeAction;

          setSessionStatus({ status, dealer_name });

          setUserCustomTheme({
            theme: checkTheme,
            userForm: customized['user_form'],
            cageBranding: customized['cage_branding'],
            cageOutline: customized['cage_outline'] || null,
            urlRedirect: urlRedirect,
            qrScanner,
            useCase: customized?.usecase ?? '',
            contactSupport: customized?.contact_support ?? false,
            dynamicCapture: data?.dynamic_capture ?? false,
            dynamicCaptureEnforce: data?.dynamic_capture_enforce ?? false,
          });

          handleCheckingVehicle(id).then(({ data }) => {
            vehicleData(data, id, theme, detectedOutline, showVehicle);
          });

          setLoadingDelay(false);

          if (!!languages && Object.keys(languages).length > 0) {
            const convertLangs = languages.map((item) => {
              if (FR_MOCK.includes(item.language_code)) {
                item.language_code = FR_DEFAULT_CODE;
              }
              if (EN_MOCK.includes(item.language_code)) {
                item.language_code = EN_DEFAULT_CODE;
              }
              return item;
            });

            handleGetActiveLangFromUrl(convertLangs);
          }

          if (!!customized && Object.keys(customized).length > 0) {
            let skipList = [];
            const capturePhotoCodes = customized.capture_photo_codes || null;
            if (capturePhotoCodes && capturePhotoCodes.length > 0) {
              setCaptureFlow(
                'CUSTOM',
                capturePhotoCodes,
                customized?.capture_photo_screen || [],
                customized?.capture_skippable || false
              );
              if (!capturePhotoCodes.includes(1) || customized['skip_vin']) {
                skipList.push(position_name['VIN']);
              }
              if (
                !capturePhotoCodes.includes(2) ||
                customized['skip_interior']
              ) {
                skipList.push(position_name['INTERIOR']);
              }
              if (
                !capturePhotoCodes.includes(3) ||
                customized['skip_odometer']
              ) {
                skipList.push(position_name['ODOMETER']);
              }
            } else {
              if (customized['skip_vin']) {
                skipList.push(position_name['VIN']);
              }
              if (customized['skip_odometer']) {
                skipList.push(position_name['ODOMETER']);
              }
              if (customized['skip_interior']) {
                skipList.push(position_name['INTERIOR']);
              }
              if (customized['rear_tire']) {
                setCaptureFlow('REAR-TIRE');
              }
            }

            if (customized['capture_4k']) {
              updateCameraSetting({
                setting: cameraConstraints4K,
                type: 'jpeg',
                name: '4k_jpeg',
              });
            }

            const disclosures = customized['disclosures'];
            const announcement = customized['announcements'];
            setloadingState((state) => ({
              ...state,
              isSkipDnA: {
                ...state.isSkipDnA,
                disclosures,
                announcement,
                both: disclosures && announcement,
              },
              skipCaptureList: skipList,
            }));
          }
        })
        .catch(() => {
          setUserCustomTheme({
            theme: handleUserCustomTheme(false),
            userForm: false,
            cageBranding: null,
          });
          setLoadingDelay(false);
          handleGetActiveLangFromUrl(langsList);
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <Suspense fallback={<RenderLoader />}>
      <Fragment>
        {loadingDelay && id ? (
          <WaitingUI />
        ) : (
          <Fragment>
            <RootRouter history={history} />
            <FlexModal />

            <Fragment>
              {isOdomDecode && (
                <MutualModal
                  className="animation-bottom-to-center"
                  isOdomDecode
                  zindex={1000}
                >
                  <OdomDecode history={history} />
                </MutualModal>
              )}
            </Fragment>

            <Fragment>
              {vinManual && (
                <MutualModal className="animation-bottom-to-center" vinManual>
                  <VinDecode history={history} />
                </MutualModal>
              )}
            </Fragment>

            <Fragment>
              {isRetake && (
                <MutualModal className="animation-bottom-to-center">
                  <RetakeUI history={history} />
                </MutualModal>
              )}
            </Fragment>
          </Fragment>
        )}
        <WarningModal
        visible={isWarningVisible}
        onOk={handleWarningOk}
        warningType={invalidWarning}
      />
      </Fragment>
    </Suspense>
  );
};

const mapStateToProps = (state) => ({
  vinReducer: state.vinReducer,
  odomReducer: state.odomReducer,
  isRetake: state.retakeReducer.isRetake,
  langReducer: state.languageProviderReducer,
  themeReducer: state.themeReducer,
});

const mapDispatchToProps = (dispatch) => ({
  themeAction: bindActionCreators(themeActions, dispatch),
  updateNetWork: bindActionCreators(updateNetWorks, dispatch),
  sessionAction: bindActionCreators(sessionActions, dispatch),
  partnerAction: bindActionCreators(partnerActions, dispatch),
  changeLocaleAction: bindActionCreators(changeLocaleActions, dispatch),
  cameraSettingAction: bindActionCreators(cameraSettingActions, dispatch),
  vinDecodeAction: bindActionCreators(vinDecodeActions, dispatch),
});
export default Sentry.withProfiler(
  connect(mapStateToProps, mapDispatchToProps)(SubRoot)
);
// REFERENCE => https://wicg.github.io/netinfo/#dom-connectiontype-wimax
